import { Link } from "react-router-dom";
import { Share2 } from "lucide-react";
import { Logo } from "./Header";
import ShareButton from "./ShareButton";

const CITIES = [["Maharashtra", "Mumbai"], ["Delhi", "New Delhi"], ["Karnataka", "Bengaluru"], ["Telangana", "Hyderabad"], ["Tamil Nadu", "Chennai"], ["Maharashtra", "Pune"], ["West Bengal", "Kolkata"], ["Gujarat", "Ahmedabad"], ["Rajasthan", "Jaipur"], ["Uttar Pradesh", "Lucknow"]];

export default function Footer() {
  return (
    <footer className="border-t gold-line mt-24 bg-[#06070a]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <Logo />
          <p className="text-sm text-gray-400 max-w-md leading-relaxed">India's premium marketplace for pre-owned cars. Buy directly from private owners or from trusted dealer showrooms across every state and union territory.</p>
        </div>
        <div>
          <p className="eyebrow mb-4">Explore</p>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><Link to="/cars" className="hover:text-[#E5C158]">All Cars</Link></li>
            <li><Link to="/cars?seller_type=private" className="hover:text-[#E5C158]">Private Owners</Link></li>
            <li><Link to="/dealers" className="hover:text-[#E5C158]">Dealer Stores</Link></li>
            <li><Link to="/sell" className="hover:text-[#E5C158]">Sell Your Car</Link></li>
            <li><ShareButton className="flex items-center gap-1.5 text-[#E5C158] hover:underline" testid="footer-share-app"><Share2 className="w-3.5 h-3.5" />Share Website</ShareButton></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Popular Cities</p>
          <ul className="grid grid-cols-2 gap-2 text-sm text-gray-400">
            {CITIES.map(([s, c]) => <li key={c}><Link to={`/city/${encodeURIComponent(s)}/${encodeURIComponent(c)}`} className="hover:text-[#E5C158]">{c}</Link></li>)}
            <li><Link to="/cities" className="text-[#E5C158]" data-testid="footer-all-cities">All cities →</Link></li>
          </ul>
        </div>
      </div>
      <div className="shimmer-line" />
      <p className="text-center text-xs text-gray-500 py-6">© {new Date().getFullYear()} carsalemarket.com — All rights reserved.</p>
    </footer>
  );
}
